import SurveyList from "../Views/Survey/SurveyList.vue";
import SurveyEdit from "../Views/Survey/SurveyEdit.vue";
import SurveyCreate from "../Views/Survey/SurveyCreate.vue";
import { MODULES } from "../Constants/modules.js";
import { adminGuard } from "./guards.js";

export const surveyRoutes = [
    {
        path: "/surveys/edit/:id",
        name: "surveys.edit",
        component: SurveyEdit,
        beforeEnter: adminGuard,
        meta: {
                module: MODULES.SURVEYS,
            menu: {
                parent: 'surveys',
                child: null
            },
            breadcrumb: {
                title: "Formulaires",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Tous les formulaires",
                            link: {name: 'surveys.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/surveys/create",
        name: "surveys.create",
        component: SurveyCreate,
        beforeEnter: adminGuard,
        meta: {
                module: MODULES.SURVEYS,
            menu: {
                parent: 'surveys',
                child: null
            },
            breadcrumb: {
                title: "Formulaires",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Tous les formulaires",
                            link: {name: 'surveys.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/surveys",
        name: "surveys.list",
        component: SurveyList,
        meta: {
                module: MODULES.SURVEYS,
            menu: {
                parent: 'surveys',
                child: null
            },
            breadcrumb: {
                title: "Formulaires",
                nav: {
                    all: {
                        active: "Tous les formulaires",
                        inactive: []
                    }
                }
            }
        },
    }
];
